import React from 'react';
import Link from 'next/link';
import { useTranslations } from '../../locales/useTranslations';
import { BiSearchAlt, BiEnvelope } from 'react-icons/bi';

const NoJobsAvailable = () => {
    const { t } = useTranslations();

    return (
        <div className="no-jobs-available">
            <div className="no-jobs-available__icon">
                <BiSearchAlt />
            </div>
            <h4 className="no-jobs-available__title">
                {t('career_no_jobs_title')}
            </h4>
            <p className="no-jobs-available__text">
                {t('career_no_jobs_description')}
            </p>
            <Link
                href="mailto:info@simplify-data.de?subject=Initiativbewerbung"
                className="no-jobs-available__btn"
            >
                <BiEnvelope /> {t('career_no_jobs_apply')}
            </Link>
        </div>
    );
};

export default NoJobsAvailable;
